<template>
  <div class="Contactus">
    <PageBanner :bannerObj="bannerObj"></PageBanner>
    <ContactList class="wow bounceInUp"></ContactList>
    <ContactMap></ContactMap>
    <ContactFrom class="wow bounceInUp"></ContactFrom>
  </div>
</template>
<script>
import PageBanner from "@/components/common/pageBanner"
import ContactMap from "@/components/Contactus/ContactMap.vue"
import ContactList from "@/components/Contactus/ContactList.vue"
import ContactFrom from "@/components/Contactus/ContactFrom.vue"
export default {
  name: "Contactus",
  metaInfo () {
    return {
      title: "联系我们",
      meta: [
        { name: "keywords", content: "广州统计师事务所" },
        { name: "description", content: "广州统计师事务所" },
      ],
    }
  },
  data () {
    return {
      bannerObj: {
        lableZh: "联系我们",
        lableEn: "CONTACT US",
        bannerImg: require("@/assets/img/contactus/banner.png"),
      },
    }
  },
  mounted () {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init()
    })
  },
  components: {
    PageBanner,
    ContactMap,
    ContactList,
    ContactFrom,
  },
};
</script>
<style lang="scss" scoped>
.Contactus {
  padding: 0 0 50px 0;
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
